import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Make sure you're using react-router
import Logo from '../../assets/images/2025.webp';
import qrLogo from '../../assets/images/qr-icon.svg';
import Swal from 'sweetalert2';
import { api } from '../../Api';

function Home() {
  const [acaraList, setAcaraList] = useState([]);
  const [selectedAcara, setSelectedAcara] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/acara') // adjust to your actual endpoint
      .then((response) => {
        setAcaraList(response.data.data); // assuming `data.data` holds the acara list
      })
      .catch((error) => {
        Swal.fire('Error', 'Failed to load acara data', 'error');
      });
  }, []);

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const selected = acaraList.find(item => item.id === parseInt(selectedId));
    setSelectedAcara(selected);
  };

  const handleProceed = () => {
    if (!selectedAcara) {
      Swal.fire('Warning', 'Pilih Acara terlebih dahulu', 'warning');
      return;
    }
    navigate('/scan', { state: { id: selectedAcara.id, tgl_acara: selectedAcara.tgl_acara } });
  };

  return (
    <div className="login-page">
  <img src={Logo} alt="Filadelfia Blessing Family" className="logo" />

  <div className="mt-4">
    {acaraList.length === 0 ? (
      <p style={{color:'#fff'}} className="text-red-500 text-center">Belum ada acara</p>
    ) : (
      <>
        <select
          style={{ width: '80%', padding: '10px' }}
          onChange={handleSelectChange}
          className="p-2 rounded border"
        >
          <option value="">Pilih Acara</option>
          {acaraList.map((acara) => (
            <option key={acara.id} value={acara.id}>
              {acara.masteracara.nama_acara} - {acara.tgl_acara}
            </option>
          ))}
        </select>

        <button
          onClick={handleProceed}
          className="mt-4 p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Lanjut ke Scan
        </button>
      </>
    )}
  </div>
</div>

  );
}

export default Home;
